import React from 'react'

const ZanyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="73"
      height="15"
      fill="none"
      viewBox="0 0 73 15"
    >
      <path
        fill="#000"
        d="M61.248.39c1.48 0 2.504.918 2.504 2.47 0 1.55-1.024 2.466-2.504 2.466H59.56V.389h1.688zm0 3.75c.78 0 1.218-.437 1.218-1.283 0-.845-.435-1.283-1.218-1.283h-.43V4.14h.43v.002zM65.674 4.168h2.102v1.158h-3.36V.389h3.329v1.158H65.67v.72h1.715v1.13h-1.709v.773l-.002-.002zM71.619.39h1.314l-1.589 4.936h-1.59L68.16.389h1.348l1.058 3.542L71.619.39zM21.485.002c-1.781 0-3.49.72-4.748 2.006a6.908 6.908 0 00-1.965 4.84v7.359h6c.044-.54.404-4.713.552-7.233a.153.153 0 01.048-.099.163.163 0 01.1-.044c.038 0 .074.013.103.04.03.023.047.059.053.094l.53 7.24H28.2v-7.36a6.906 6.906 0 00-1.968-4.84A6.65 6.65 0 0021.485 0v.002zM6.33 9.392a.135.135 0 01-.106-.038.157.157 0 01.084-.272l7.122-1.164V.461H0v4.775c.745 0 4.65 0 7.04.01.04-.003.078.011.107.038a.156.156 0 01.015.214.147.147 0 01-.1.054L.003 6.756v7.436H13.43v-4.8c-.584 0-4.68.006-7.101 0h.002zM38.204.46c0 .76 0 4.74-.006 7.18 0 .04-.013.077-.038.109a.139.139 0 01-.102.05.157.157 0 01-.11-.034.171.171 0 01-.053-.102L36.71.46h-7.29v13.692h4.706c0-.595-.006-4.77 0-7.236 0-.04.013-.081.038-.108a.151.151 0 01.102-.055c.04 0 .078.01.11.038.029.023.05.06.054.102l1.14 7.26h7.32V.462h-4.686zM52.325.46c-.015 1.542-.04 4.312-.044 6.179a.155.155 0 01-.143.153.144.144 0 01-.105-.034.158.158 0 01-.056-.094L51.001.463h-6.894v5.048c.047.682.507 2.614 4.108 3.615l3.888 1.038s.272.157 0 .35l-7.991-1.103v4.746h13.43V.46h-5.218z"
      ></path>
    </svg>
  )
}

export default ZanyIcon